module.exports = __webpack_public_path__ + "img/91.dd702da8.jpg";